/* unplugin-vue-components disabled */import { render } from "./modal.vue?vue&type=template&id=d9807fa6&scoped=true"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import "./modal.vue?vue&type=style&index=0&id=d9807fa6&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9807fa6"],['__file',"src/controls/modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d9807fa6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d9807fa6', __exports__)) {
    api.reload('d9807fa6', __exports__)
  }
  
  module.hot.accept("./modal.vue?vue&type=template&id=d9807fa6&scoped=true", () => {
    api.rerender('d9807fa6', render)
  })

}


export default __exports__